import React from 'react'
import ColorModeContext from '../context/ColorModeContext'
import themesConfig from '../lib/theme'
import { ThemeProvider } from '@mui/material'
import { KioskMode } from './KioskMode'
import { SnackbarComponent } from './Snackbar'
import { useLocalStorage } from '../hooks/useLocalStorage'
import SnackBarContext from '../context/SnackBarContext'

const ThemeMode = ({ children }: any) => {
  const [mode, setMode] = React.useState<'light' | 'dark'>('light')
  const [appKioskMode] = useLocalStorage('kioskMode', false)
  const [open, setOpen] = React.useState<boolean>(false)
  const [severity, setSeverity] = React.useState<String>('success')
  const [message, setMessage] = React.useState<String>('')
  const themeMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'))
      },
    }),
    [],
  )
  const theme = React.useMemo(
    () =>
      themesConfig(mode),
    [mode],
  )

  const snackBarHandler = React.useMemo(
    () => ({
      toggleSnackbar: (message: String, severity: String) => {
        setMessage(message)
        setSeverity(severity)
        setOpen((prevMode) => (prevMode === true ? false : true))
      }
    }), [])

  return (
    <ColorModeContext.Provider value={themeMode}>
      <ThemeProvider theme={theme}>
        <SnackBarContext.Provider value={snackBarHandler}>
          <KioskMode isKioskMode={appKioskMode}>
            {children}
            <SnackbarComponent open={open} message={message} severity={severity} />
          </KioskMode>
        </SnackBarContext.Provider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  )
}

export default ThemeMode